// extracted by mini-css-extract-plugin
export default {"checkboxList":"CheckboxList_checkboxList__E9jRk","label":"CheckboxList_label__uaYUT","checkbox":"CheckboxList_checkbox__uBggf"};